import {sendPageViewEvent, trackSingle} from "../services/analytics";

const usePageViews = (location) => {
  const pathname = location.pathname;
  console.log("redirecting to", pathname);
  // TODO Hadar - check if works

  let parentStoreUrl = window.location.hostname;
  let titleFromRoute = pathname.split("/"); // /setup --> Setup ~~~ /setup/facebook --> Facebook

  titleFromRoute = titleFromRoute[titleFromRoute.length - 1];
  if (titleFromRoute) {
    titleFromRoute = titleFromRoute[0].toUpperCase() + titleFromRoute.substring(1).toLowerCase();

    sendPageViewEvent({
      page_title: titleFromRoute,
      page_location: parentStoreUrl,
      page_path: pathname,
    });

    trackSingle({
      content_name: titleFromRoute,
    })
  }
};

export default usePageViews;
